export enum KpiSATypes {
  'LOAD_REQUEST' = '@kpiSA/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@kpiSA/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@kpiSA/LOAD_FAILURE',
}

export interface IPoint {
  time: string;
  value: number;
}

export interface IKpi {
  card: string;
  data: IPoint[];
  protocolos: number[];
  qtd: number;
  total: number;
  percentual: number;
}

export interface KpiSAState {
  readonly data: IKpi[];
  readonly error: boolean;
  readonly loading: boolean;
}
